import {useMount as _useMount} from 'react-use';

import api from '@api';

export const useMount = (
  me: MeStore,
  setInitialValues: React.Dispatch<React.SetStateAction<{}>>
) => {
  _useMount(async () => {
    const res = await api.teams.getOne(me.teamId);
    setInitialValues({
      intensity: res.intensity,
      isEmailSending: res.isEmailSending,
      isSMSSending: res.isSMSSending,
      isConnectSending: res.isConnectSending,
    });
  });
};
